<div class="spinner">
  <app-loader></app-loader>
</div>
<ng-container>
  <h2 mat-dialog-title>{{this.orderService.isOrderingPhysician ? 'Select Ordering Physician' : 'Select Referring Physician'}}</h2>
  <mat-dialog-content class="mat-typography">
    @if (dataSourceValue && matTableConfig?.columnList.length > 0) {
      <app-clindx-mat2-table class="clindxMat2__table"
        [(filterChipset)]="chipList" [config]="matTableConfig" [dataSource]="dataSourceValue"
        [filterConfig]="filterConfig"
        (filterRemoved)="removeChip($event)">
        <ng-template #Actions let-element>
          <button mat-raised-button color="primary" (click)="sendSelectedDetail(element)" class="select-btn">Select</button>
        </ng-template>
      </app-clindx-mat2-table>
    }
  </mat-dialog-content>
  <mat-dialog-actions [class.align]="(isScreenSmall | async ) && noteDialogisopen">
    @if ((isScreenSmall | async ) && noteDialogisopen ||
      !(isScreenSmall | async ) && noteDialogisopen) {
      <div class="note-section">
        @if ((isScreenSmall | async )) {
          <div class="close" (click)="noteDialogisopen = false">
            <mat-icon>cancel</mat-icon>
          </div>
        }
        <p><span>*</span>Note: Please consider the following while searching for physician:</p>
        <ol>
          <li>To search by NPI number, type in all 10 digits.</li>
          <li>To search by FN, LN, City, State, and Zip code, enter at least 2 characters.</li>
          <li>State search criteria can only be used in combination with other filter criteria.</li>
          <li>Results will appear only after entering the search criteria.</li>
        </ol>
      </div>
    }
    @if ((isScreenSmall | async ) && !noteDialogisopen) {
      <button (click)="noteDialogisopen = true" mat-button>Show
      Note</button>
    }
    <button mat-button color="primary" mat-dialog-close>Close</button>
  </mat-dialog-actions>
</ng-container>
